/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Option_Restart_WeeksInputs */

const en_us2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart weeks (back to week 1)`)
};

const pt_br2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar semanas (voltar à semana 1)`)
};

const es_419_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar semanas (volver a la semana 1)`)
};

const pt_pt2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar semanas (voltar à semana 1)`)
};

const fr_fr2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommencer les semaines (retour à la semaine 1)`)
};

const de_de2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochen neu starten (zurück zu Woche 1)`)
};

const it_it2_plan_build_option_restart_weeks = /** @type {(inputs: Plan_Build_Option_Restart_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riavvia le settimane (torna alla 1)`)
};

/**
* | output |
* | --- |
* | "Restart weeks (back to week 1)" |
*
* @param {Plan_Build_Option_Restart_WeeksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_option_restart_weeks = /** @type {((inputs?: Plan_Build_Option_Restart_WeeksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Option_Restart_WeeksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_option_restart_weeks(inputs)
	if (locale === "es-419") return es_419_plan_build_option_restart_weeks(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_option_restart_weeks(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_option_restart_weeks(inputs)
	if (locale === "de-DE") return de_de2_plan_build_option_restart_weeks(inputs)
	if (locale === "it-IT") return it_it2_plan_build_option_restart_weeks(inputs)
	return en_us2_plan_build_option_restart_weeks(inputs)
});
export { plan_build_option_restart_weeks as "plan-build.option_restart_weeks" }